<template>
  <header class="">
    <!--menu left-->
    <v-navigation-drawer
      v-if="isLogIn"
      fixed
      app
      v-model="drawer"
      width="77"
      left
      style="padding-top: 10px; padding-left: 2px"
    >
      <v-list dense>
        <div style="padding-top: 10px"></div>

        <v-layout>
          <v-flex xs12 class="text-center py-4">
            <router-link
              to="/home/my_Courses"
              tag="i"
              class="material-icons blue-grey--text button-menu"
            >
              school
            </router-link>
            <div style="font-size: 0.7rem;margin-top: -5px; text-align: center">
              Mis cursos
            </div>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12 class="text-center py-4">
            <router-link
              to="/home/settings"
              tag="i"
              class="material-icons blue-grey--text button-menu"
            >
              settings
            </router-link>
            <div
              style="font-size: 0.7rem; margin-top: -5px; text-align: center"
            >
              Ajustes
            </div>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12 class="text-center py-4" @click="logout">
            <i
              class="fas fa-sign-out-alt blue-grey--text button-menu"
              style="font-size: 2.5rem"
            >
            </i>
            <div
              style="font-size: 0.7rem; margin-top: -1px; text-align: center"
            >
              Salir
            </div>
          </v-flex>
        </v-layout>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      v-if="isLogIn"
      class="bg-gradient-blue"
      flat
      dark
      app
      fixed
    >
      <v-toolbar-title style="width: 300px" class="ml-0">
        <v-toolbar-side-icon
          @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">Cursos Online</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <car></car>

      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile style="width: 150px" @click="logout">
            Salir
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
  </header>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import car from "./../pages/payment/badget_top.vue";

export default {
  name: "sideBarBash",
  components: {
    car
  },
  created() {},
  data() {
    return {
      state: true,
      isLogIn: localStorage.getItem("isLogIn"),
      CurrentUser: "",
      dialog: false,
      drawer: null
    };
  },
  computed: {
    ...mapState,
    ...mapGetters({ isLoggzedIn: "auth/isLoggedIn", carShop: "carShop" })
  },
  methods: {
    logout() {
      var url = "/api/v1/logout";
      axios
        .post(
          url,
          (axios.defaults.headers.common["Authorization"] =
            "Bearer " + localStorage.getItem("a_t")),
          {}
        )
        .then(response => {
          this.$store.dispatch("auth/setStatusLogin", false);
          localStorage.clear();
          window.location.reload();
        })
        .catch(err => {
          // this.stateButton = false;
          toastr.error("Usuario o contraseña incorrectos!");
        });
    }
  }
};
</script>
